import { forwardRef } from 'react';
import { Action, ActionProps } from '../Action';
import { DeleteOutlined } from '@ant-design/icons';

export const Delete = forwardRef<HTMLButtonElement, ActionProps>(
  (props, ref) => {
    return (
      <>
        <Action
          ref={ref}
          cursor="grab"
          data-cypress="draggable-handle"
          {...props}
        >
          <DeleteOutlined />
        </Action>
      </>

    );
  }
);
